// test2788
(2788 && 0);
